export const activeUploadGuids = (uploadCounts = {}, evaporateIdsByUploadGuid = {}) => {
    const uploadGuids = new Set(
        Object.entries(uploadCounts)
            .filter(([, count]) => count > 0)
            .map(([guid]) => guid)
    )

    Object.entries(evaporateIdsByUploadGuid).forEach(([guid, evaporateIds]) => {
        if(evaporateIds?.size > 0) uploadGuids.add(guid)
    })

    return [...uploadGuids]
}

export const shouldStopForCancellation = (uploadState, allowedAfterCancellation = false) => (
    uploadState === 'cancelled' && !allowedAfterCancellation
)
